module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"feeType":{"Category":"Category","Manual":"Activé pour ce produit"}},"fr":{"feeType":{"Category":"Catégorie","Manual":"Activé pour ce produit"}}}')
  delete Component.options._Ctor
}
